import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../../web/components-v2/Theme/theme';

const slotMachineColumnWidth = 160;
const prizeColumnWidth = 112;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
	},
	row: {
		alignItems: 'stretch',
		display: 'flex',
		gap: SPACE[8],
		transition: 'opacity 150ms ease-in-out',
	},
	rowCard: {
		alignItems: 'center',
		background: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		cursor: 'pointer',
		display: 'flex',
		flex: 1,
		gap: SPACE[16],
		minWidth: 0,
		padding: SPACE[16],
	},
	rowCardSelected: {
		border: `1px solid ${THEME.colors.primary.main}`,
	},
	rowColContent: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	rowColHeader: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		letterSpacing: '0.04em',
		textTransform: 'uppercase',
	},
	rowDescriptionCol: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: SPACE[12],
		minWidth: 0,
	},
	rowPrizeCol: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: prizeColumnWidth,
	},
	rowSlotMachineCol: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[12],
		width: slotMachineColumnWidth,
	},
	selectTrigger: {
		background: THEME.colors.background.light,
		width: '100%',
	},
});
